import React from "react";
import { FileText, Trash2 } from "lucide-react";

function DraftsPopup({ drafts, formTitle, onOpen, onDelete, onClose, formatDate }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="drafts-popup-title"
        className="w-full max-w-[560px] overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-xl"
      >
        <div className="px-7 pb-5 pt-7">
          <div className="mb-1.5 flex items-center gap-2.5">
            <div className="flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-xl border border-gray-200 bg-gray-50">
              <FileText size={16} className="text-gray-500" aria-hidden="true" />
            </div>
            <h2 id="drafts-popup-title" className="text-base font-medium text-gray-900">
              Brouillons — {formTitle}
            </h2>
          </div>
          <p className="ml-[42px] text-[13px] leading-relaxed text-gray-400">
            Reprends une demande ou supprime-la si elle n'est plus nécessaire.
          </p>
        </div>

        <div className="mx-7 h-px bg-gray-100" />

        <div className="flex max-h-[300px] flex-col gap-2 overflow-y-auto px-7 py-4">
          {drafts.map((draft) => {
            const dateLabel = formatDate(draft);

            return (
              <div
                key={draft._id}
                className="group flex items-center justify-between rounded-xl border border-gray-200 bg-white transition-all hover:border-blue-300 hover:bg-blue-50/60"
              >
                <button
                  type="button"
                  onClick={() => onOpen(draft)}
                  className="min-w-0 flex-1 px-3.5 py-3 text-left"
                  aria-label={`Ouvrir le brouillon ${draft.numeroFormulaire}`}
                >
                  <span className="flex flex-wrap items-center gap-2">
                    <span className="break-all text-[13px] font-medium text-gray-900">
                      {draft.numeroFormulaire}
                    </span>
                    <span className="rounded-full border border-gray-200 bg-gray-100 px-2 py-0.5 text-[11px] tracking-tight text-gray-500">
                      Brouillon
                    </span>
                  </span>
                  {dateLabel && (
                    <span className="mt-1.5 inline-block w-fit rounded-md border border-blue-200 bg-blue-50 px-2 py-0.5 text-[12px] font-medium text-blue-600">
                      {dateLabel}
                    </span>
                  )}
                </button>
                <button
                  type="button"
                  onClick={() => onDelete(draft._id)}
                  className="mr-3 rounded-lg border border-transparent px-2.5 py-1.5 text-gray-400 transition-all hover:border-red-200 hover:bg-red-50 hover:text-red-500"
                  aria-label={`Supprimer le brouillon ${draft.numeroFormulaire}`}
                  title="Supprimer le brouillon"
                >
                  <Trash2 size={15} aria-hidden="true" />
                </button>
              </div>
            );
          })}
        </div>

        <div className="mx-7 h-px bg-gray-100" />

        <div className="flex justify-end gap-2 px-7 py-5">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-gray-200 px-4 py-2 text-[13px] text-gray-500 transition hover:bg-gray-50"
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg bg-blue-600 px-4 py-2 text-[13px] font-medium text-white transition hover:bg-blue-700"
          >
            Nouvelle demande
          </button>
        </div>
      </div>
    </div>
  );
}

export default DraftsPopup;

